<template>
  <div id="chargerReport">
    <div class="filter-container">
      <div id="search">
        <!-- <el-input v-model="listQuery.curveNo" style="width: 200px;" class="filter-item" placeholder="DeviceNo" @keyup.enter.native="searchTable" />
        <el-button class="filter-item" type="primary" icon="el-icon-search" @click="searchTable">Search</el-button> -->
        <el-input v-model="listQuery.sn" clearable :placeholder="$t('lease.machineSN')" class="input-with-select deviceNameTable" @clear="searchTable(tableObj.deviceName)">
          <el-button slot="append" icon="el-icon-search" @click="searchTable" />
        </el-input>
        <el-button class="filter-item" :title="$t('titles.uploadChargeRecord')" type="primary" icon="el-icon-upload2" style="margin-top: -2px;margin-bottom: 0;float: right;" @click="uploadVersion" />

      </div>
    </div>

    <el-table v-loading.body="listLoading" :data="list" element-loading-text="Loading" border fit highlight-current-row>
      <el-table-column :label="$t('QR.deviceSN')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.sn }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('dashboard.LatestUpdate')" width="130" align="center">
        <template slot-scope="scope">
          <span>{{ formatTime(scope.row.lastUpdate,0) }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('QR.Records')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.recordSize }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('QR.Uploader')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.updateName }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column :label="$t('charger.companyId')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.companyId }}</span>
        </template>
      </el-table-column> -->
      <el-table-column :label="$t('QR.Uploadtime')" width="230" align="center">
        <template slot-scope="scope">
          <span>{{ formatTime(scope.row.updateTime,0) }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('yhubReport.Operating')" align="center">
        <template slot-scope="scope">
          <!-- <el-button type="success" round size="medium" @click="handleItemDetail(scope.row)">{{ $t("message.moreInfo") }}</el-button> -->
          <el-button type="primary" :title="$t('titles.toDetail')" size="mini" icon="el-icon-view" @click="handleItemDetail(scope.row)" />
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
      <div class="pagination-container">
        <el-pagination
          v-if="pageshow"
          background
          current-page.sync="listQuery.pageInfo.page"
          :page-sizes="listQuery.pageInfo.pageList"
          :page-size="listQuery.pageInfo.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="listQuery.pageInfo.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <el-dialog :close-on-click-modal="false" :visible.sync="uploadFileDialog">
      <el-form label-position="left" label-width="130px" style="width: 80%; margin-left:50px;">
        <el-form-item :label="$t('QR.FileName')">
          <el-upload ref="upload" class="upload-demo" action="" :on-change="handleChange" :file-list="fileList" :auto-upload="false">
            <el-button slot="trigger" size="small" type="primary" :loading="uploading">{{ $t('QR.SelectFile') }}</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="" style="color:red;">
          * {{ $t('QR.PleaseNote') }}
          <!-- * 请注意：此文档应以SN号命名，否则会导致上传失败！ -->
        </el-form-item>
        <el-form-item :label="$t('QR.ForExample')">
          03006722.pyl / PY03006722.pyl
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="uploadFileDialog = false">{{ $t('button.Cancel') }}</el-button>
        <el-button type="primary" @click="submitForm">{{ $t('button.Submit') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { upload, chargerSimpleList } from '@/api/QR'
import timezoons from '@/utils/timezones.json'
import { pagination } from '@/utils/init_table' // 分页
import i18n from '@/i18n'

export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: 'success',
        draft: 'gray',
        deleted: 'danger'
      }
      return statusMap[status]
    }
  },
  data() {
    return {
      list: null,
      listLoading: true,
      // listQuery: {
      //   curveNo: null,
      //   pageInfo: pagination(),
      //   value5: '',
      //   sn: ''
      // },

      // 分页----start
      listQuery: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow: true,
      // 分页----end
      fileList: [],
      dialogStatus: '',
      uploadFileDialog: false,
      uploading: false,
      options: timezoons,
      value: 8,
      pickerOptions2: {
        shortcuts: [{
          text: 'late Week',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: 'last Month',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: 'Three Month',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  created() {
    this.queryList()
  },
  methods: {
    queryList() {
      this.listLoading = true
      var param = {
        companyIdList: [],
        sn: this.listQuery.sn,
        pageNum: this.listQuery.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery.pageInfo.pageSize // 分页--每一页的列表的行数 10 20 50
      }
      chargerSimpleList(param).then(response => {
        this.list = response.resultModel.list
        this.list.forEach(v => {
          // if (v.sn && v.sn.indexOf('PY') == -1)v.sn = 'PY' + v.sn
        })
        this.listQuery.pageInfo.total = response.resultModel.total // 分页

        this.listLoading = false
      })
    },
    searchTable() {
      this.listQuery.pageInfo.pageNum = 1
      this.pageshow = false
      this.queryList()
      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    // 分页----start
    handleSizeChange(val, e) { // 每一页的列表的行数 10 20 50
      this.listQuery.pageInfo.pageSize = val
      this.queryList()
    },
    handleCurrentChange(val, e) { // 选中某一页
      this.listQuery.pageInfo.pageNum = val
      this.queryList()
    },
    // 分页----end
    handleItemDetail(row) {
      // this.$router.push({ path: '/QR/chargerReportDetail',
      //   query: {
      //     sn: row.sn
      //   }
      // })
      var routeData = this.$router.resolve({
        path: '/QR/chargerReportDetail',
        query: {
          sn: row.sn
        }
      })
      window.open(routeData.href, '_self')
    },
    uploadVersion() { // 上传
      for (var key in this.dataModel) {
        this.dataModel[key] = null
      }
      this.uploadFileDialog = true
    },
    formatTime(s, i) {
      if (s) {
        s = s.split(' ')
        return s[i]
      }
      return s
    },
    handleChange(file, fileList) { // 上传弹窗
      this.fileList.push(file)
      this.$refs.upload.clearFiles()
    },
    submitForm() { // 上传弹窗--提交
      this.uploading = true
      var file = this.fileList.pop()
      // console.log('file--', file)
      if (file && file.name) {
        var fileName = file.name.split('.')[0]
        if (fileName.length == 10 && fileName[0] == 'P' && fileName[1] == 'Y')fileName = fileName.slice(2)
        if (fileName.length == 8 && /^[0-9]{8}$/.test(fileName)) {
          upload(file, this.value).then(response => {
            if (response.resultCode == 1001) {
              this.uploadFileDialog = false
              this.list = response.list
              this.$notify({
                title: 'SUCCESS',
                message: 'Upload Success',
                type: 'success',
                duration: 2000
              })
              this.queryList()
              this.uploading = false
            } else {
              this.$notify({
                title: 'ERROR',
                message: 'Upload error',
                type: 'error',
                duration: 2000
              })
              this.uploading = false
            }
          })
        } else {
          this.$notify({
            title: 'ERROR',
            message: i18n.t('QR.uploadFailed'),
            type: 'error',
            duration: 2000
          })
          this.uploading = false
        }
      }
    }
  }
}
</script>
<style lang="scss">
#chargerReport{
  background: #fff;
  padding: 13px 20px;
  #search .el-input-group {
    width: 40%!important;
    max-width: 300px!important;
    // margin-top: 13px;
  }
}
</style>
